import React, { useEffect, useState } from 'react';

export function dateToInputValue(date) {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Champ date natif : brouillon local pour permettre la saisie manuelle (jour / mois / année)
 * sans reset React à chaque segment.
 */
export default function CommerceDateInput({
  value,
  onChange,
  min,
  disabled = false,
  className = '',
  onValidationError,
}) {
  const [draft, setDraft] = useState(() => dateToInputValue(value));

  useEffect(() => {
    setDraft(dateToInputValue(value));
  }, [value == null ? null : value.getTime()]);

  const handleChange = (e) => {
    const raw = e.target.value;
    setDraft(raw);
    onValidationError?.('');

    if (!raw) {
      onChange?.(null);
      return;
    }

    if (raw.length < 10) return;

    const d = new Date(`${raw}T12:00:00`);
    if (Number.isNaN(d.getTime())) return;

    onChange?.(d);
  };

  return (
    <input
      type="date"
      className={className}
      value={draft}
      min={min}
      disabled={disabled}
      onChange={handleChange}
    />
  );
}
